export const FaqData = [
  {
    qustion: "1. Da li deca do 5 godina plaćaju smeštaj?",
    answer:
      "Cene koje smo naveli iskazane su po najmu apartmana i obuhvataju maksimalan broj osoba bez obzira na uzrast. Ukoliko imate bilo kakvih drugih pitanja, slobodno nas kontaktirajte.",
  },
  {
    qustion: "2. Da li postoji mogućnost pomoćnog ležaja?",
    answer:
      "Kapacitet svakog apartmana ograničen je u smislu broja osoba koje se mogu smestiti u njemu. Međutim, ukoliko imate potrebu za dodatni ležaj za bebu, rado ćemo ga obezbediti i osigurati Vašu udobnost tokom boravka kod nas. Molimo Vas da nas blagovremeno obavestite o vašoj potrebi, kako bismo bili sigurni da ćemo ispoštovati sve vaše zahteve.",
  },
  {
    qustion: "3. Da li je obezbeđen parking?",
    answer:
      "Svakom gostu naših apartmana je na raspolaganju parking mesto, koje je osigurano i bezbedno. Naš cilj je da učinimo vaš boravak kod nas što prijatnijim i bez stresa, pa se nadamo da ćete uživati u pogodnostima koje pruža naš objekat.",
  },
  {
    qustion: "4. Da li postoji pospust za wellnes?",
    answer:
      "Za svakog gosta naših apartmana je omogućen posput za korišćcenje wellnesa.",
  },
];
